import { Cancel, CheckCircle } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const FboStatusBadge = ({ isFbo }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={isFbo ? t('common.badges.fbo') : t('common.badges.nonFbo')}
      size='small'
      color={isFbo ? 'success' : 'default'}
      variant='filled'
      icon={isFbo ? <CheckCircle /> : <Cancel />}
    />
  );
};
